import React from 'react';
import { Tabs, ITabItemProps } from 'ui-toolkit';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import type { FCWithChildren } from '../../types/FCWithChildren';

interface IVendorDashTabsProps {
  activeTabIndex: number;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}

const clientUrl = ClientUrlFactory().urlFor;

export const VendorDashTabs: FCWithChildren<IVendorDashTabsProps> = ({ activeTabIndex, suffix, prefix, children }) => {
  const vendorTabs: ITabItemProps[] = [
    {
      text: 'Title Search',
      to: clientUrl.vendorOrders(),
    },
    {
      text: 'Payoff',
      to: clientUrl.vendorPayoffs(),
    },
    {
      text: 'Tax Certification',
      to: clientUrl.vendorTaxCertifications(),
    },
  ];
  const activeTab = vendorTabs[activeTabIndex] ? vendorTabs[activeTabIndex] : vendorTabs[0];
  return (
    <Tabs tabs={vendorTabs} activeTab={activeTab} prefix={prefix} suffix={suffix}>
      {children}
    </Tabs>
  );
};
